module.exports = __webpack_public_path__ + "static/img/jqjs.24f2cc2b.png";